import React, { FC } from "react";
import FormFields from "./FormFields";

export const ApplicationForm: FC = () => {
  return (
    <div className="w-full max-w-[1000px] flex flex-col items-center justify-center px-4 py-9 mt-2 bg-form_bg rounded-2xl">
      <h2 className="pb-5 text-2xl font-bold">Подати заявку на участь </h2>
      <div className="w-full">
        <FormFields />
      </div>
    </div>
  );
};

export default ApplicationForm;
